var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 0.75H2.25C1.78587 0.75 1.34075 0.934374 1.01256 1.26256C0.684374 1.59075 0.5 2.03587 0.5 2.5V16.5C0.5 16.9641 0.684374 17.4092 1.01256 17.7374C1.34075 18.0656 1.78587 18.25 2.25 18.25H12.75C13.2141 18.25 13.6592 18.0656 13.9874 17.7374C14.3156 17.4092 14.5 16.9641 14.5 16.5V6L9.25 0.75ZM5.31075 13.1663C5.04038 13.42 4.64137 13.5338 4.17675 13.5338C4.08666 13.5347 3.99661 13.5295 3.90725 13.518V14.7657H3.125V11.3217C3.47802 11.2691 3.83473 11.2451 4.19162 11.25C4.679 11.25 5.0255 11.3428 5.25913 11.5291C5.48138 11.7059 5.63188 11.9955 5.63188 12.3368C5.631 12.6797 5.51725 12.9694 5.31075 13.1663ZM8.64188 14.3519C8.27438 14.6573 7.71525 14.8025 7.03188 14.8025C6.62238 14.8025 6.33275 14.7762 6.13587 14.75V11.3226C6.48903 11.2711 6.84562 11.2468 7.2025 11.25C7.86487 11.25 8.29538 11.369 8.63138 11.6227C8.9945 11.8923 9.222 12.3219 9.222 12.9388C9.222 13.6064 8.97788 14.0675 8.64188 14.3519ZM11.875 11.9237H10.5345V12.7209H11.7875V13.3631H10.5345V14.7666H9.74175V11.2762H11.875V11.9237ZM9.25 6.875H8.375V2.5L12.75 6.875H9.25Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfSvg);
export default __webpack_public_path__ + "static/media/PDFSvg.b12793437e26eaee5de6f69142c90226.svg";
export { ForwardRef as ReactComponent };